module.exports = __webpack_public_path__ + "assets/img/fitness.e6bf951b.png";